"use strict";

var _slicedToArray = require("/Users/sngr/develop/kitekure-site/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VFXProvider = void 0;

var React = __importStar(require("react"));

var react_1 = require("react");

var context_1 = require("./context");

var vfx_player_1 = __importDefault(require("./vfx-player"));

var canvasStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  "z-index": 9999,
  "pointer-events": "none"
};

var VFXProvider = function VFXProvider(props) {
  var _react_1$useState = react_1.useState(null),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      _player = _react_1$useState2[0],
      setPlayer = _react_1$useState2[1];

  react_1.useEffect(function () {
    var canvas = document.createElement("canvas");

    for (var _i = 0, _Object$entries = Object.entries(canvasStyle); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          k = _Object$entries$_i[0],
          v = _Object$entries$_i[1];

      canvas.style.setProperty(k, v.toString());
    }

    if (props.zIndex !== undefined) {
      canvas.style.setProperty("z-index", props.zIndex.toString());
    }

    document.body.appendChild(canvas);
    var player = new vfx_player_1.default(canvas, props.pixelRatio);
    setPlayer(player);
    player.play();
    return function () {
      player.stop();
      player.destroy();
      canvas.remove();
    };
  }, [props.pixelRatio, props.zIndex]);
  return React.createElement(React.Fragment, null, React.createElement(context_1.VFXContext.Provider, {
    value: _player
  }, props.children));
};

exports.VFXProvider = VFXProvider;